module.exports = __webpack_public_path__ + "assets/images/1fec12389c0204348e3a67732971eaba.png";